const nameSpace = 'advertiser/insertionOrders'

export const actions = {
  SET_INSERTION_ORDERS: `${nameSpace}/SET_INSERTION_ORDERS`,
  SET_LOADING: `${nameSpace}/SET_LOADING`,
  CLEAR_LOADING: `${nameSpace}/CLEAR_LOADING`,
  GET_AGENCY_MARGIN_LIST: `${nameSpace}/GET_AGENCY_MARGIN_LIST`,
  GET_SALES_ACCOUNT_LIST: `${nameSpace}/GET_SALES_ACCOUNT_LIST`,
  SET_IO_STATUS: `${nameSpace}/SET_IO_STATUS`,
  CHANGE_IO: `${nameSpace}/CHANGE_IO`,
}

export const getters = {
  loading: `${nameSpace}/loading`,
  searchResult: `${nameSpace}/searchResult`,
  menuList: `${nameSpace}/menuList`,
  agencyMarginList: `${nameSpace}/agencyMarginList`,
  salesAccountList: `${nameSpace}/salesAccountList`,
  permissionLevel: `${nameSpace}/permissionLevel`,
}
